import type React from 'react';
import { Icon } from '@iconify/react';
import { Chip } from '@heroui/react';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';

type BranchChipProps = {
    branchName: string;
};

/**
 * The branch beside the navbar's "Import products": the page's header reads
 * "Import products · <branch>" (`useNavbarAccessory`). The route gives the
 * title; which branch it imports into is the page's own state, as the
 * operation editor's version chip is. A long name truncates rather than
 * pushing the title out of the bar; on a phone the page leaves it out.
 */
export const BranchChip: React.FC<BranchChipProps> = ({ branchName }) => (
    <Chip
        className="max-w-xs"
        variant="soft"
        {...getNodeTestIdProp('branch-import-branch-chip')}
    >
        <Icon aria-hidden icon="solar:shop-2-bold-duotone" />
        <Chip.Label className="truncate">{branchName}</Chip.Label>
    </Chip>
);
